import { render } from "./FormContent.vue?vue&type=template&id=412322a2&scoped=true"
import script from "./FormContent.vue?vue&type=script&lang=js"
export * from "./FormContent.vue?vue&type=script&lang=js"

import "./FormContent.vue?vue&type=style&index=0&id=412322a2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\bfern\\Documents\\la-vuelta-trama\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-412322a2"]])

export default __exports__